module.exports = __webpack_public_path__ + "static/memories-and-flowers-of-a-warrior-in-a-sandbox_2007-fef8057cf90e3e6eb34defa85564fb35.jpg";